import ApiClient from '../ApiClient';

class ChatappChannel extends ApiClient {
  constructor() {
    super('channels/chatapp_channel', { accountScoped: true });
  }
}

export default new ChatappChannel();
